module.exports = __webpack_public_path__ + "87234eb12c27f8814758ecd92799bb13.MP3";